interface PackageMatchingTargeting {
  ecpm: number;
  organization_id: number;
  package_id: number;
  package_type: string;
  unit_count: number;
}

interface PackageDiscoveryResponse {
  deals_considered_count: number;
  deals_matching_targeting: PackageMatchingTargeting[];
  sellers_considered_count: number;
  units_not_targeted_count: number;
  units_targeted_by_deals_count: number;
  units_targeted_count: number;
}

export interface IPackageDiscoveryParams {
  allowed_buyer_access: string[];
  currency: string;
  flight_from: string;
  flight_to: string;
  for_bidding: boolean;
  inventory_targeting: {
    co2e_emissions_score_threshold: number;
    creative_format_exclusions: string[];
    creative_formats: string[];
    geofencegroup_exclusion_ids: number[];
    geofencegroup_ids: number[];
    language_exclusion_ids: number[];
    language_ids: number[];
    location_exclusion_ids: number[];
    location_ids: number[];
    market_exclusion_ids: number[];
    market_ids: number[];
    mediatype_exclusion_ids: number[];
    mediatype_ids: number[];
    network_exclusion_ids: number[];
    network_ids: number[];
    site_exclusion_ids: number[];
    site_ids: number[];
    unit_exclusion_ids: number[];
    unit_ids: number[];
    unit_tag_exclusions: string[];
    unit_tags: string[];
    unitpack_exclusion_ids: number[];
    unitpack_ids: number[];
  };
}

export default class DealDiscoveryStatistics {
  dealsConsideredCount: number;
  dealsMatchingTargeting: PackageMatchingTargeting[];
  sellersConsideredCount: number;
  unitsNotTargetedCount: number;
  unitsTargetedCount: number;
  unitsTargetedByDealsCount: number;

  constructor(
    dealsConsideredCount: number,
    dealsMatchingTargeting: PackageMatchingTargeting[],
    sellersConsideredCount: number,
    unitsNotTargetedCount: number,
    unitsTargetedCount: number,
    unitsTargetedByDealsCount: number,
  ) {
    this.dealsConsideredCount = dealsConsideredCount;
    this.dealsMatchingTargeting = dealsMatchingTargeting;
    this.sellersConsideredCount = sellersConsideredCount;
    this.unitsNotTargetedCount = unitsNotTargetedCount;
    this.unitsTargetedCount = unitsTargetedCount;
    this.unitsTargetedByDealsCount = unitsTargetedByDealsCount;
  }

  get coverageRate(): number {
    return (this.unitsTargetedByDealsCount / this.unitsTargetedCount) * 100;
  }

  get coverageRateFormatted(): string {
    return this.coverageRate < 1 ? '<1%' : `${this.coverageRate.toFixed(0)}%`;
  }

  get sellersTargeted(): number[] {
    return [...new Set(this.dealsMatchingTargeting.map((deal) => deal.organization_id))];
  }

  get sellersTargetedCount(): number {
    return this.sellersTargeted.length;
  }

  get sellersTargetedCountFormatted(): string {
    return this.sellersTargetedCount.toLocaleString();
  }

  get unitsNotTargetedFormatted(): string {
    return this.unitsNotTargetedCount.toLocaleString();
  }

  get totalTargetedDeals(): number {
    return this.dealsMatchingTargeting.length;
  }

  get totalTargetedDealsFormatted(): string {
    return this.totalTargetedDeals.toLocaleString();
  }

  get unitsTargetedByDealsCountFormatted(): string {
    return this.unitsTargetedByDealsCount.toLocaleString();
  }

  static fromApi(apiObject: PackageDiscoveryResponse): DealDiscoveryStatistics {
    return new DealDiscoveryStatistics(
      apiObject.deals_considered_count,
      apiObject.deals_matching_targeting,
      apiObject.sellers_considered_count,
      apiObject.units_not_targeted_count,
      apiObject.units_targeted_count,
      apiObject.units_targeted_by_deals_count,
    );
  }
}
